import React, { useState } from 'react';
import { Button, Col, Popover, Row } from 'antd';
import Text from 'components/Text';
import userSelectors from 'features/user/services/selectors';
import styled, { css } from 'styled-components';
import { BUTTON_COLOR_OPTIONS } from './constant';
import userActions from 'features/user/services/actions';
import { useAppDispatch } from 'store/hooks';

const SelectColors = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='36' height='38' viewBox='0 0 36 38' fill='none'>
    <path
      d='M9.53207 1.16836C9.69034 0.957333 10.0069 0.733118 10.2575 0.970523C15.0715 5.745 19.8592 10.559 24.66 15.3467C24.8447 15.5445 25.0953 15.716 25.1348 16.0062C25.214 16.3227 25.0557 16.6392 24.8183 16.8371C21.1385 20.5037 17.4719 24.1834 13.7922 27.85C13.4888 28.1797 12.9481 28.1929 12.6447 27.8632C8.95174 24.1702 5.25878 20.4773 1.56582 16.7843C1.20971 16.4942 1.19652 15.8743 1.53944 15.5709C4.54657 12.5638 7.55369 9.54347 10.574 6.54953C9.65077 5.65267 8.74072 4.71624 7.81748 3.80619C7.6724 3.6743 7.55369 3.50284 7.46137 3.33138C8.05488 2.54003 8.84623 1.89376 9.53207 1.16836ZM12.9876 8.5411C10.4817 11.0734 7.94937 13.5925 5.43024 16.1117C10.6136 16.1117 15.7969 16.1249 20.9803 16.0985C18.3952 13.5134 15.8101 10.9415 13.2382 8.34326C13.1591 8.4092 13.0668 8.47515 12.9876 8.5411Z'
      fill='#232F3E'
    />
    <path
      d='M26.7043 23.3263C27.3901 22.192 28.1947 21.1369 29.0784 20.1609C30.2522 21.5326 31.3733 22.9834 32.1119 24.6452C32.468 25.4366 32.6658 26.3466 32.402 27.1907C32.0327 28.6547 30.6347 29.8153 29.1047 29.789C27.4693 29.8549 25.9261 28.5624 25.6756 26.9533C25.4118 25.6608 26.0844 24.421 26.7043 23.3263Z'
      fill='#232F3E'
    />
    <path
      d='M0.576534 33.297C0.563345 33.0464 0.813939 32.8881 1.03815 32.9277C12.3413 32.9277 23.6444 32.9277 34.9475 32.9277C35.1189 32.9013 35.2772 33.0068 35.4223 33.0991C35.4355 34.3389 35.4355 35.5787 35.4223 36.8185C35.4355 37.0691 35.1453 37.135 34.9607 37.1218C23.6576 37.1218 12.3544 37.1218 1.05134 37.1218C0.787561 37.1746 0.563345 36.9636 0.589724 36.6998C0.563345 35.5523 0.563345 34.418 0.576534 33.297Z'
      fill='#232F3E'
    />
  </svg>
);

const ColorsButton = () => {
  const [open, setOpen] = useState(false);
  const background = userSelectors.homeBackground();
  const dispatch = useAppDispatch();
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleClickColor = (color: string) => {
    dispatch(userActions.changeHomeBackground.fetch(color));
  };

  const content = (
    <div>
      <Row gutter={[16, 16]}>
        {Object.entries(BUTTON_COLOR_OPTIONS).map(([key, value]) => {
          const isSelected = background === value;
          return (
            <Col span={4} key={key}>
              <ItemSelectColor $selected={isSelected}>
                <ItemColorBox
                  background={value}
                  onClick={() => handleClickColor(value)}
                  $selected={isSelected}
                />
              </ItemSelectColor>
            </Col>
          );
        })}
      </Row>
    </div>
  );

  return (
    <ColorButtonContainer>
      <Popover
        arrow={false}
        content={content}
        placement='bottomLeft'
        title={
          <Text variant='H4' style={{ fontWeight: 600 }}>
            Change theme
          </Text>
        }
        trigger='click'
        open={open}
        onOpenChange={handleOpenChange}
        overlayStyle={{ width: '643px' }}
      >
        <Button onClick={(e) => e.preventDefault()} className='btn-sort'>
          <SelectColors />
        </Button>
      </Popover>
    </ColorButtonContainer>
  );
};

export default ColorsButton;

const ItemColorBox = styled.div<{ background: string; $selected: boolean }>`
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #adadad;
  box-sizing: border-box;
  background: ${({ background }) => background};
  height: 55px;
  ${({ $selected }) =>
    $selected &&
    css`
      height: 47px;
    `}
`;

const ItemSelectColor = styled.div<{ $selected: boolean }>`
  box-sizing: border-box;
  ${({ $selected }) =>
    $selected &&
    css`
      border: 1px solid #dc5500;
      padding: 4px;
      border-radius: 4px;
    `}
`;

const ColorButtonContainer = styled.div`
  display: flex;
  height: 100%;
`;